(() => {
  const globalKey = '__pbHomeV31OriginalMotionLoaded';
  if (window[globalKey]) return;
  window[globalKey] = true;

  const rootSelector = '.pb-home-original-parity';
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const rootsFor = (target) => {
    const roots = [];
    const add = (node) => {
      if (node && !roots.includes(node)) roots.push(node);
    };
    if (!target) return roots;
    if (target.matches && target.matches(rootSelector)) add(target);
    if (target.querySelectorAll) target.querySelectorAll(rootSelector).forEach(add);
    if (!roots.length && target.closest) add(target.closest(rootSelector));
    return roots;
  };

  const mount = (root) => {
    if (!root) return;
    const previous = root.__pbHomeMotionAbortController;
    if (previous) previous.abort();

    const controller = new AbortController();
    const { signal } = controller;
    root.__pbHomeMotionAbortController = controller;
    root.dataset.pbMotionReady = 'true';
    root.dataset.pbMotionReduced = reducedMotion() ? 'true' : 'false';

    const reveal = () => root.dataset.pbMotionVisible = 'true';
    if (reducedMotion() || !('IntersectionObserver' in window)) {
      reveal();
    } else {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal();
          observer.disconnect();
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      observer.observe(root);
      signal.addEventListener('abort', () => observer.disconnect(), { once: true });
    }

    signal.addEventListener('abort', () => {
      if (root.__pbHomeMotionAbortController === controller) {
        delete root.__pbHomeMotionAbortController;
        delete root.dataset.pbMotionReady;
        delete root.dataset.pbMotionVisible;
        delete root.dataset.pbMotionReduced;
      }
    }, { once: true });
  };

  const unmount = (root) => {
    if (root && root.__pbHomeMotionAbortController) root.__pbHomeMotionAbortController.abort();
  };

  const mountAll = () => document.querySelectorAll(rootSelector).forEach(mount);
  document.addEventListener('shopify:section:load', (event) => rootsFor(event.target).forEach(mount));
  document.addEventListener('shopify:section:unload', (event) => rootsFor(event.target).forEach(unmount));

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll, { once: true });
  else mountAll();
})();
